import { useUserStore } from '@/store/useUserStore'
import type { InsuranceStatus } from '@/types/user'

/**
 * The user-derived slice of the tax engine's options — "who is this taxpayer".
 * Single extraction point: every user-facing tax surface reads this so the
 * yearly (`calculateTaxes`) and monthly (`calculateMonthlyTaxes`) paths stay in
 * sync (no gpmDrift). Adding a future taxpayer-profile field touches only this
 * hook and the engine, never the call sites.
 *
 * `null` everywhere = unset → the engine calculates the maximum burden, so an
 * existing user with no KYC selection sees the same numbers as before.
 */
export interface TaxProfile {
  insuranceStatus: InsuranceStatus | null
  firstYearStartedAt: string | null
}

export const useTaxProfile = (): TaxProfile => {
  const insuranceStatus = useUserStore((state) => state.user?.kyc?.insurance_status ?? null)
  const firstYearStartedAt = useUserStore((state) => state.user?.kyc?.first_year_started_at ?? null)

  return { insuranceStatus, firstYearStartedAt }
}
